import { Component } from '@angular/core';

@Component({
  selector: 'app-add-partnerpay',
  templateUrl: './add-partnerpay.component.html',
  styleUrls: ['./add-partnerpay.component.css']
})
export class AddPartnerpayComponent {

}
